import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import {
    MDBBtn,
    MDBIcon,
    MDBModalFooter,
} from "mdb-react-ui-kit";

function RemoveBlfGroups(props) {
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();
    console.log("props :::::::::: " + JSON.stringify(props));

    return (
        <>
            <div className="d-flex align-items-center bg-danger bg-opacity-25 p-3  rounded-3 square border border-2 border-danger">
                <MDBIcon fas icon="ban" className="me-3" size="lg" color="danger" />
                {props.groupInfo.devices ? (
                    <div>
                        {t("deleteBLFGroupConfirm", {
                            Groupname: `${props.groupInfo?.group_name}`,
                            macAdress: `(${props.groupInfo?.devices})`
                        })}
                    </div>
                ) : (
                    <div>
                        {t("RemoveBlfText")} {props.groupInfo?.group_name}
                    </div>
                )}
            </div>


            <MDBModalFooter className='p-0 mt-3 pt-2'>
                <MDBBtn color="secondary" onClick={(e) => props.onClose(e)}>
                    {t("close")}
                </MDBBtn>
                <MDBBtn onClick={(e) => props.onsave(props.groupInfo)}>{t("remove")}</MDBBtn>
            </MDBModalFooter>
        </>
    );
}
export default RemoveBlfGroups;

